import styled from 'styled-components';

export const Wrapper = styled.div<{ isDragActive: boolean; zoom: number; emptyView?: boolean }>`
    width: 100%;
    height: calc(100vh - 146px);
    border-top-width: 2px;
    position: relative;
    border-top-style: dashed;
    border-top-color: ${({ isDragActive }) => (isDragActive ? '#0781D7' : 'rgba(0,0,0,0)')};
    margin: 0 auto;
    z-index: 3;
    padding: 16px 0;
`;

export const DragDropElement = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    z-index: 2;
    background: rgba(0, 0, 0, 0.2);
`;
